export default __webpack_public_path__ + "static/media/react.4a12c782.png";